module.exports = __webpack_public_path__ + "static/final-e64dc4c3dd67f93af23396975dd1a070.jpg";